import React from 'react'
import Footer from '../../Component/Footer'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import AddCost from './AddCost'

const Cost = () => {
    return (
        <div>
            <Header/>
            <Menu/>
            <div className="content-wrapper">
                <AddCost/>
            </div>
            <Footer/>
        </div>
    )
}

export default Cost